function setupMdc() {
  // add dropdown select listeners
  const selects = [].map.call(
    document.querySelectorAll(".mdc-select"),
    function (el) {
      return new mdc.select.MDCSelect(el);
    },
  );
  selects.map((select) => {
    select.listen("MDCSelect:change", () => {
      select.root.querySelector("input").value = select.value;
      select.root
        .querySelector("input")
        .onchange({ target: { value: select.value } });
    });
  });

  // add textfield listeners
  [].map.call(document.querySelectorAll(".mdc-text-field"), function (el) {
    return new mdc.textField.MDCTextField(el);
  });

  // add button listeners
  [].map.call(document.querySelectorAll(".mdc-button"), function (el) {
    return new mdc.ripple.MDCRipple(el);
  });

  // add menu listeners
  const menus = [].map.call(
    document.querySelectorAll(".mdc-menu"),
    function (el) {
      return new mdc.menu.MDCMenu(el);
    },
  );
  menus.map((menu) => {
    menu.open = false;
    const toggle = document.querySelector(`#${menu.root.id}-toggle`);
    if (toggle) {
      toggle.onclick = () => {
        menu.open = true;
      };
    }
  });

  // add tab listeners
  const tabBar = document.querySelector(".mdc-tab-bar");
  if (tabBar !== null) {
    try {
      new mdc.tabBar.MDCTabBar(tabBar);
    } catch (err) {
      console.error(err);
    }
  }
}

document.addEventListener("turbo:load", setupMdc);
document.addEventListener("turbo:render", setupMdc);
